module.exports = require('./checkout-js.js')
